export default "__VITE_ASSET__c5e05e21__"